export const isIntegrationTest = () =>
  Boolean(navigator.userAgent === 'puppeteer' || typeof Cypress === 'object');

export const isBrainTestUser = (email) =>
  isIntegrationTest() && email === 'brain-test@healthy.io';
